module.exports = __webpack_public_path__ + "f406422450f76f973ace649c84c89f4c.svg";